import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'deleteHtmlLabel',
})
export class DeleteHtmlLabelPipe implements PipeTransform {
	transform(value: string): string {
		if (!value) {
			return '';
		}

		return value.replace(/<\/?[^>]+(>|$)/g, '');
	}
}
